import React from 'react';
import { AuthPageStyles } from '../../authentication/styles';
import { Box, Grid, Paper, Typography, useMediaQuery, useTheme, Button } from '@material-ui/core';
import { useBasicDetails } from '../../store/storeApi';
import { useTranslation } from 'react-i18next';
import { ResponseReuseMessagePageStyles } from '../styles/ResponseReuseMessagePageStyles';
import { useParams, useHistory } from 'react-router-dom';
import { routeMappings } from '../../constants';
import { ResponseReuseRouteParam } from '../../taskList/constants';

export const ResponseReuseMessagePage = (): JSX.Element => {
  const {
    template: { settings },
    candidate,
    currentWorkflowItem,
  } = useBasicDetails();
  const history = useHistory();
  const { responseReuseType } = useParams<{ responseReuseType?: ResponseReuseRouteParam }>();
  const { t } = useTranslation();
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const classes = AuthPageStyles(settings);
  const styles = ResponseReuseMessagePageStyles();
  let heading,
    subHeading1,
    subHeading2: string | null = null;

  if (responseReuseType) {
    switch (responseReuseType) {
      case 'complete-rr':
        heading = t('fullRRPageMsgForAllTasksHeader');
        subHeading1 = t('fullRRPageMsg1', { firstName: candidate?.firstName });
        subHeading2 = t('fullRRPageMsg2All');
        break;
      case 'full-rr':
        heading = t('fullRRMsgForSingleTaskHeader');
        subHeading1 = t('fullRRPageMsg1', { firstName: candidate?.firstName });
        subHeading2 = t('fullRRPageMsg2Single');
        break;
      case 'partial-rr':
        heading = t('partialRRHeadingPage');
        subHeading1 = `${t('partialRRMsg1OnTaskPage')} ${t('partialRRMsg2OnTaskPage')}`;
        break;
      default:
        break;
    }
  }

  const onSubmit = (): void => {
    sessionStorage.setItem('responseReuseAcknowledged', '1');
    history.push(`${routeMappings[currentWorkflowItem.code]}/${currentWorkflowItem.id}`);
  };

  return (
    <Grid container justify="center" className={classes.container}>
      <Grid item xl={6} lg={8} className={classes.grid}>
        <Paper elevation={lgUp ? 1 : 0} className={classes.paper}>
          {heading && (
            <Typography variant="h2" className={styles.headingColor}>
              {heading}
            </Typography>
          )}
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            className={styles.outerBox}>
            <Box mt={2} p={2} className={styles.innerBox}>
              {subHeading1 && (
                <Typography variant="body1" className={styles.subHeadingColor}>
                  {subHeading1}
                </Typography>
              )}
              {subHeading2 && (
                <Typography variant="body1" className={`${styles.pos} ${styles.subHeadingColor}`}>
                  {subHeading2}
                </Typography>
              )}
            </Box>
            <Button className={styles.button} onClick={onSubmit}>
              {t('gotIt')}
            </Button>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
